import { useTranslation } from "@privacy/translations";
import type { TranslateTimeElapsed } from "../pages/RegistrationsGridPage/getTimeElapsed";
import { getFormattedTimeElapsed } from "../pages/RegistrationsGridPage/getTimeElapsed";

export const useFormattedDateTime = (dateTime: string) => {
  const { formatDate, t } = useTranslation();

  const translateTimeElapsedUnits: TranslateTimeElapsed = (dateValue, unit) => {
    if (dateValue === 1) return t(`DynamicGrid.timeElapsed${unit}`);
    return t(`DynamicGrid.timeElapsed${unit}Plural`, { value: dateValue });
  };

  return {
    formattedDate: formatDate(dateTime, { showTime: true }),
    formattedTimeElapsed: getFormattedTimeElapsed(dateTime, translateTimeElapsedUnits),
  };
};
